/**
 * This function verifies if Optanon has no vendors defined
 * to set the vendor consent value in our logic to true,
 * avoiding false negatives
 */
export const areVendorsEnabled = () => {
  const generalVendors = window.Optanon?.GetDomainData?.()?.GeneralVendors;
  return Array.isArray(generalVendors) && generalVendors.length > 0;
};
